export default __webpack_public_path__ + "static/media/life.cba3aa7e.jpg";